<template>
  <div class="grid sm:grid-cols-2 lg:h-full">
    <div class="flex justify-center items-center bg-white">
      <div class="text-center xl:text-left xl:py-10 px-5 xl:px-28 w-full">
        <img
          src="@/assets/img/hike-variant-2.png"
          class="logo_main_sc2 mx-auto xl:mx-0"
          alt="Hike Society"
        />
        <p class="subtitle-info mt-5 leading-5 lg:leading-6 text-lg lg:text-md">
          Forma parte de esta comunidad exclusiva de amantes del senderismo y la montaña 
          aventura.
        </p>
        <p class="mt-5 leading-5 lg:leading-6 text-lg lg:text-md">
          Al convertirte en miembro de <strong>Hike Society</strong>, accederás
          a un mundo de beneficios diseñados para mejorar tus experiencias al
          aire libre:
        </p>
        <ul class="mt-5 leading-5 text-left lg:leading-6 text-lg lg:text-md list-item list-disc">
          <li>Acceso a rutas, eventos y lanzamientos</li>
          <li>Participación en los mejores hikes de la región</li>
          <li>Acumulación de puntos</li>
          <li>Descuentos</li>
          <li>Y mucho más!</li>
        </ul>
      </div>
    </div>
    <div class="bg-section_s1"></div>
  </div>
</template>

<style scoped>
.logo_main_sc2 {
  max-width: 280px;
  width: 100%;
  margin: 10px auto;
}
.bg-section_s1 {
  background-image: url("@/assets/img/bg-s2.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 60vh;
}

@media screen and (min-width: 640px) {
  .bg-section_s1 {
    height: 100%;
  }
}

@media screen and (max-width: 639px) {
  .bg-section_s1 {
    background-position: 65% center !important;
  }
  .logo_main_sc2 {
  max-width: 180px;
  padding: 10px;
  width: 100%;
  margin: 10px auto;
}
}
</style>
